// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nav {
  --color: var(--ion-color-primary);
  background: none;
  width: 10vw;
  height: calc(5vh - 2vw);
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}
.nav svg {
  fill: none;
  stroke-width: 7px;
  stroke-linecap: round;
  stroke-linejoin: round;
}
.nav svg use:nth-of-type(1) {
  opacity: 1;
  stroke-dashoffset: 221;
  stroke-dasharray: 46 249;
  transition: stroke-dashoffset 0.12s linear 0.2s, stroke-dasharray 0.12s linear 0.2s, opacity 0s linear 0.2s;
}
.nav svg use:nth-of-type(2) {
  animation: stroke-animation-reverse 1.2s ease-out forwards;
}
.nav input {
  position: absolute;
  height: 100%;
  width: 100%;
  z-index: 2;
  cursor: pointer;
  opacity: 0;
}
.nav input:checked + svg use:nth-of-type(1) {
  stroke-dashoffset: 175;
  stroke-dasharray: 0 295;
  opacity: 0;
  transition: stroke-dashoffset 0.07s linear 0.07s, stroke-dasharray 0.07s linear 0.07s, opacity 0s linear 0.14s;
}
.nav input:checked + svg use:nth-of-type(2) {
  animation: stroke-animation 1.2s ease-out forwards;
}

.nav .onState {
  stroke: var(--ion-color-primary);
  transition: all 1.2s ease-out;
}
.nav .offState {
  stroke: var(--ion-text-primary);
  transition: all 1.2s ease-out forwards;
}

@keyframes stroke-animation {
  0% {
    stroke-dashoffset: 295;
    stroke-dasharray: 25 270;
  }
  50% {
    stroke-dashoffset: 68;
    stroke-dasharray: 59 236;
  }
  65% {
    stroke-dashoffset: 59;
    stroke-dasharray: 59 236;
  }
  100% {
    stroke-dashoffset: 68;
    stroke-dasharray: 59 236;
  }
}
@keyframes stroke-animation-reverse {
  0% {
    stroke-dashoffset: 68;
    stroke-dasharray: 59 236;
  }
  50% {
    stroke-dashoffset: 290;
    stroke-dasharray: 25 270;
  }
  65% {
    stroke-dashoffset: 295;
    stroke-dasharray: 25 270;
  }
  100% {
    stroke-dashoffset: 290;
    stroke-dasharray: 25 270;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/reward-item/reward-item.component.scss"],"names":[],"mappings":"AAIA;EACE,iCAAA;EACA,gBAAA;EACA,WAAA;EACA,uBAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAHF;AAIE;EACE,UAAA;EACA,iBAAA;EACA,qBAAA;EACA,sBAAA;AAFJ;AAMM;EACE,UAAA;EACA,sBAAA;EACA,wBAAA;EACA,2GAAA;AAJR;AAMM;EACE,0DAAA;AAJR;AAQE;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,eAAA;EACA,UAAA;AANJ;AAUU;EACE,sBAAA;EACA,uBAAA;EACA,UAAA;EACA,8GAAA;AARZ;AAUU;EACE,kDAAA;AARZ;;AAgBE;EACE,gCAAA;EACA,6BAAA;AAbJ;AAeE;EACE,+BAAA;EACA,sCAAA;AAbJ;;AAgBA;EACE;IACE,sBAAA;IACA,wBAAA;EAbF;EAeA;IACE,qBAAA;IACA,wBAAA;EAbF;EAeA;IACE,qBAAA;IACA,wBAAA;EAbF;EAeA;IACE,qBAAA;IACA,wBAAA;EAbF;AACF;AAgBA;EACE;IACE,qBAAA;IACA,wBAAA;EAdF;EAgBA;IACE,sBAAA;IACA,wBAAA;EAdF;EAgBA;IACE,sBAAA;IACA,wBAAA;EAdF;EAgBA;IACE,sBAAA;IACA,wBAAA;EAdF;AACF","sourcesContent":["// :host{\n//   margin: 10vw auto;\n// }\n\n.nav {\n  --color: var(--ion-color-primary); \n  background: none;\n  width: 10vw;\n  height: calc(5vh - 2vw);\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  svg {\n    fill: none;\n    stroke-width: 7px;\n    stroke-linecap: round;\n    stroke-linejoin: round;\n\n    use {\n\n      &:nth-of-type(1) {\n        opacity: 1;\n        stroke-dashoffset: 221;\n        stroke-dasharray: 46 249;\n        transition: stroke-dashoffset .12s linear .2s, stroke-dasharray .12s linear .2s, opacity 0s linear .2s;  \n      }\n      &:nth-of-type(2) {\n        animation: stroke-animation-reverse 1.2s ease-out forwards;\n      } \n    }\n  }\n  input {\n    position: absolute;\n    height: 100%;\n    width: 100%;\n    z-index: 2;\n    cursor: pointer;\n    opacity: 0;\n    &:checked {\n      + svg {\n        use {\n          &:nth-of-type(1) {\n            stroke-dashoffset: 175;\n            stroke-dasharray: 0 295;\n            opacity: 0;\n            transition: stroke-dashoffset .07s linear .07s, stroke-dasharray .07s linear .07s, opacity 0s linear .14s;  \n          }\n          &:nth-of-type(2) {\n            animation: stroke-animation 1.2s ease-out forwards;\n          } \n        }\n      }\n    }\n  }\n}\n.nav{\n  .onState{\n    stroke: var(--ion-color-primary);\n    transition: all 1.2s ease-out ;\n  }\n  .offState{\n    stroke: var(--ion-text-primary);\n    transition: all 1.2s ease-out forwards;\n  }\n}\n@keyframes stroke-animation {\n  0% {\n    stroke-dashoffset: 295;\n    stroke-dasharray: 25 270;\n  }\n  50% {\n    stroke-dashoffset: 68;\n    stroke-dasharray: 59 236;\n  }\n  65% {\n    stroke-dashoffset: 59;\n    stroke-dasharray: 59 236;\n  }\n  100% {\n    stroke-dashoffset: 68;\n    stroke-dasharray: 59 236;\n  }\n}\n\n@keyframes stroke-animation-reverse {\n  0% {\n    stroke-dashoffset: 68;\n    stroke-dasharray: 59 236;\n  }\n  50% {\n    stroke-dashoffset: 290;\n    stroke-dasharray: 25 270;\n  }\n  65% {\n    stroke-dashoffset: 295;\n    stroke-dasharray: 25 270;\n  }\n  100% {\n    stroke-dashoffset: 290;\n    stroke-dasharray: 25 270;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
